import { Component } from '@angular/core';

@Component({
  selector: 'app-coach-dashboard-page',
  templateUrl: './coach-dashboard.component.html',
  styleUrls: ['./coach-dashboard.component.scss'],
})
export class CoachDashboardComponent {}
